import { render, staticRenderFns } from "./orderManage.vue?vue&type=template&id=70b1c68e&scoped=true"
import script from "./orderManage.vue?vue&type=script&lang=js"
export * from "./orderManage.vue?vue&type=script&lang=js"
import style0 from "./orderManage.vue?vue&type=style&index=0&id=70b1c68e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b1c68e",
  null
  
)

export default component.exports